import React from 'react';
import "../../css/Layout.css";

const Layout = ({ children }) => {
    return (
        <div className="layout">
            <main className="main-content">
                {children}
            </main>

            <footer className="footer">
                <div className="footer-content">
                    <p>&copy; 2026 Cloudosed / Xiaoyun ZHONG. All rights reserved.</p>
                </div>
            </footer>
        </div>
    );
};

export default Layout;